"use strict";

var ctx = require.context('./validators', false, /\.js$/);

module.exports = ctx.keys().reduce(function (obj, key) {
    obj[key.replace(/(.*\/)?(.*)\.js$/, '$2')] = ctx(key).default;
    return obj;
}, {});


/** WEBPACK FOOTER **
 ** ./src/validators.js
 **/